import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";
import {LastMatchesLayoutDataColumnDomainModel} from "./game-h2h.competitor.layout-data.column.domain-model";

export class LastMatchesLayoutDataColumnViewModel extends BaseViewModel{
  domainModel: LastMatchesLayoutDataColumnDomainModel

  get title(): String {
    return this.domainModel.title;
  }
}